import { Container, IconButton, makeStyles, Paper, Typography, Snackbar, Grid, TextField, Button, InputAdornment } from '@material-ui/core'
import React, { useEffect } from 'react'
import BackIcon from '@material-ui/icons/ArrowBackIos';
import { Alert } from '@material-ui/lab';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import Parse from 'parse';
import { async } from 'parse/lib/browser/Storage';

const useStyles = makeStyles(theme => ({
    header: {
        backgroundColor: theme.palette.nav.app,
        [theme.breakpoints.up('sm')]: {
            paddingRight: 104,
            paddingLeft: 104
        },
        [theme.breakpoints.down('sm')]: {
            paddingRight: 48,
            paddingLeft: 48
        },
    },
    headerText: {
        color: '#000',
        fontSize: 28,
        marginTop: 10,
        marginBottom: 10
    },
    titleText: {
        fontSize: 18,
        fontWeight: 600,
        margin: '20px 0px'
    }

}));

const MyInfo = ({ changeView }) => {

    const classes = useStyles()

    const user = JSON.parse(localStorage.user)

    const [data, setData] = React.useState({
        name: "",
        email: "",
        password: "",
        newPassword: "",
        confirmPassword: ""
    });
    const [open, setOpen] = React.useState(false);
    const [errorOpen, setErrorOpen] = React.useState(false);
    const [showPassword, setShowPassword] = React.useState({
        password: false,
        newPassword: false,
        confirmPassword: false
    })
    const [errors, setErrors] = React.useState({
        password: false,
        newPassword: false,
        confirmPassword: false
    });


    useEffect(() => {
        // const user = JSON.parse(localStorage.user)
        setData({
            ...data,
            name: user.n,
            email: user.e
        });
    }, [])

    const validateForm = async () => {
        let validForm = true;
        const formErrors = {};

        if (data.password || data.newPassword) {
            // validate user password
            const Customers = Parse.Object.extend("RegisteredCustomers");
            const query = new Parse.Query(Customers);
            query.equalTo("objectId", user.id);
            query.equalTo("p", data.password)
            const results = await query.first();

            formErrors.password = !results;
            if (!results) validForm = false;

            formErrors.newPassword = !data.newPassword
            if (!data.newPassword) validForm = false;

            // validate confirm password
            const confirm = data.newPassword !== data.confirmPassword
            formErrors.confirmPassword = confirm;
            if (confirm) validForm = false;


            setErrors(formErrors);
            return validForm;
        } else {
            return validForm
        }

    };

    const saveChanges = (validForm) => {
        const Customers = Parse.Object.extend("RegisteredCustomers");
        const query = new Parse.Query(Customers);
        return query.get(user.id)
            .then((userToUpdate) => {
                if (data.name) userToUpdate.set("n", data.name);
                if (data.email) userToUpdate.set("e", data.email);
                if (data.password && validForm) userToUpdate.set("p", data.newPassword);
                return userToUpdate.save()
            });

    }

    const handleSubmit = async () => {

        const validForm = await validateForm();

        if (!validForm) return;

        try {
            const updatedUser = await saveChanges(validForm);
            localStorage.user = JSON.stringify({ ...updatedUser.attributes, id: updatedUser.id })
            setOpen(true);
        } catch (error) {
            setErrorOpen(true);
        }
    };

    const handleClickShowPassword = (name) => {
        setShowPassword({
            ...showPassword,
            [name]: !showPassword[name],
        });
    }

    const handleFieldChange = (e) => {
        const { name, value } = e.target;
        setData({
            ...data,
            [name]: value,
        });
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };



    return (
        <div>
            <div className={classes.header}>
                {

                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", height: 115 }}>
                        <div style={{ zIndex: 1 }}>

                            <p className={classes.headerText}>
                                <IconButton onClick={() => { changeView(null, 1) }} aria-label="delete" size="small">
                                    <BackIcon style={{ fontSize: 24 }} />
                                </IconButton> Mi información</p>
                        </div>
                    </div>
                }


            </div>
            <Container maxWidth="lg" style={{ paddingTop: 30 }} >
                <Paper elevation={2} style={{ padding: '20px 60px', borderRadius: 16 }}>
                    <Typography className={classes.titleText}>
                        Mi información
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={24} sm={24} md={12} spacing={3} >
                            <TextField value={data.name} fullWidth onChange={handleFieldChange} label="Nombre y Apellido" name='name' />
                        </Grid>
                        <Grid item xs={24} sm={24} md={12} spacing={3} >
                            <TextField value={data.email} fullWidth onChange={handleFieldChange} label="Correo electronico" name='email' />
                        </Grid>

                        <Typography className={classes.titleText}>
                            Cambio de contraseña
                        </Typography>
                        <Grid item xs={24} sm={24} md={12} spacing={3} >
                            <TextField
                                value={data.password} fullWidth onChange={handleFieldChange}
                                name='password'
                                label="Contraseña actual (dejar en blanco para dejar sin cambios)"
                                type={showPassword.password ? 'text' : 'password'}
                                error={errors.password}
                                helperText={errors.password && "La contraseña ingresada no es correcta"}
                                InputProps={{
                                    endAdornment:
                                        < InputAdornment position="end" >
                                            <IconButton
                                                onClick={() => handleClickShowPassword('password')}
                                            >
                                                {showPassword.password ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                }}
                            />
                        </Grid>
                        <Grid item xs={24} sm={24} md={12} spacing={3} >
                            <TextField
                                value={data.newPassword} fullWidth onChange={handleFieldChange}
                                name='newPassword'
                                label="Nueva contraseña (dejar en blanco para dejar sin cambios)"
                                type={showPassword.newPassword ? 'text' : 'password'}
                                error={errors.newPassword}
                                helperText={errors.newPassword && "Debes ingresar una contraseña"}
                                InputProps={{
                                    endAdornment:
                                        < InputAdornment position="end" >
                                            <IconButton
                                                onClick={() => handleClickShowPassword('newPassword')}
                                            >
                                                {showPassword.newPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                }}
                            />
                        </Grid>
                        <Grid item xs={24} sm={24} md={12} spacing={3} >
                            <TextField
                                value={data.confirmPassword} fullWidth onChange={handleFieldChange}
                                name='confirmPassword'
                                label="Confirmar nueva contraseña"
                                type={showPassword.confirmPassword ? 'text' : 'password'}
                                //onBlur={validateField}
                                error={errors.confirmPassword}
                                helperText={errors.confirmPassword && "Las contraseñas no coinciden"}
                                InputProps={{
                                    endAdornment:
                                        < InputAdornment position="end" >
                                            <IconButton
                                                onClick={() => handleClickShowPassword('confirmPassword')}
                                            >
                                                {showPassword.confirmPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} style={{ paddingTop: 20, textAlign: 'end' }} >
                            <Button style={{ borderRadius: 30 }} onClick={handleSubmit} variant="contained" component="span" color="secondary">Guardar cambios</Button>
                        </Grid>
                    </Grid>
                </Paper>
                <Snackbar open={open} autoHideDuration={1700} onClose={handleClose}>
                    <Alert onClose={handleClose} severity="success">
                        Los cambios se guardaron correctamente!
                    </Alert>
                </Snackbar>
                <Snackbar open={errorOpen} autoHideDuration={1700} onClose={handleClose}>
                    <Alert onClose={handleClose} severity="danger">
                        No se pudieron guardar los cambios!
                    </Alert>
                </Snackbar>
            </Container>

        </div>
    )
}

export default MyInfo